module.exports = __webpack_public_path__ + "img/icon-file.17d189ba.svg";